<template>
    <select class="form-select"
        :id="id"
        :name="name"
        v-model="selected">
        <option value="" disabled>{{this.placeHolderText}}</option>
        <option v-for="(choice, index) in choices" :key="index" :value="choice.value">
            {{this.getTranslatedText(choice.text, 'fields.options') ?? choice.text}}
        </option>
    </select>
</template>
<script>
import {inject} from "vue";

export default {
    props: ["choices","value","minlength","maxlength","type","placeholder","id","name","label"],
    emits: ["update:model-value", "input"],
    setup(props) {
        const { getTranslatedText } = inject('app'); // app is being provided in Application.vue
        return {
            getTranslatedText
        }
    },
    data() {
        return {
        }
    },
    created() {
    },
    computed: {
        placeHolderText() {
            let placeholderText = !!this.placeholder && this.placeholder.length > 0 ? this.placeholder : '__select__';
            return this.getTranslatedText(placeholderText, 'fields.placeholders');
        },
        selected: {
            get(){ return this.value ?? '' },
            set(v){ this.$emit('input', v) }
        }
    },
    methods: {
    }
}
</script>
